/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '../../completed.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../app/completed/payment-method/pix/completed.payment-method.pix.component';
import * as i3 from 'ngx-clipboard/dist/src/clipboard.directive';
import * as i4 from 'ngx-clipboard/dist/src/clipboard.service';
import * as i5 from '@ngx-translate/core/src/translate.pipe';
import * as i6 from '@ngx-translate/core/src/translate.service';
import * as i7 from 'ngx-toastr';
const styles_CompletedPaymentMethodPixComponent:any[] = [i0.styles];
export const RenderType_CompletedPaymentMethodPixComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_CompletedPaymentMethodPixComponent,data:{}});
export function View_CompletedPaymentMethodPixComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),0,'img',[['alt',
      'Pix QR-Code']],[[8,'src',4]],[[(null as any),'error']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i2.CompletedPaymentMethodPixComponent = _v.component;
    if (('error' === en)) {
      const pd_0:any = ((<any>_co.changeQrCodeSource($event)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),
      i1.ɵeld(2,0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
      ['\n'])),(_l()(),i1.ɵeld(4,0,(null as any),(null as any),3,'a',[['class','btn btn-sm btn-link'],
      ['ngxClipboard','']],(null as any),[[(null as any),'cbOnSuccess'],[(null as any),
      'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i2.CompletedPaymentMethodPixComponent = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,5).onClick($event.target)) !== false);
      ad = (pd_0 && ad);
    }
    if (('cbOnSuccess' === en)) {
      const pd_1:any = ((<any>_co.copied()) !== false);
      ad = (pd_1 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(5,212992,(null as any),0,i3.ClipboardDirective,
      [i4.ClipboardService,i1.Renderer],{targetElm:[0,'targetElm'],cbContent:[1,'cbContent']},
      {cbOnSuccess:'cbOnSuccess'}),(_l()(),i1.ɵted(6,(null as any),['\n    ','\n'])),
      i1.ɵpid(131072,i5.TranslatePipe,[i6.TranslateService,i1.ChangeDetectorRef]),
      (_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i2.CompletedPaymentMethodPixComponent = _v.component;
    const currVal_1:any = '';
    const currVal_2:any = _co.paymentCode;
    _ck(_v,5,0,currVal_1,currVal_2);
  },(_ck,_v) => {
    var _co:i2.CompletedPaymentMethodPixComponent = _v.component;
    const currVal_0:any = i1.ɵinlineInterpolate(1,'https://quickchart.io/qr?text=',
        _co.paymentCodeQr,'&size=250');
    _ck(_v,0,0,currVal_0);
    const currVal_3:any = i1.ɵunv(_v,6,0,i1.ɵnov(_v,7).transform('COMPLETED.COPY_PIX_PAYMENT_CODE'));
    _ck(_v,6,0,currVal_3);
  });
}
export function View_CompletedPaymentMethodPixComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'completed-payment-method-pix',
      ([] as any[]),(null as any),(null as any),(null as any),View_CompletedPaymentMethodPixComponent_0,
      RenderType_CompletedPaymentMethodPixComponent)),i1.ɵdid(1,49152,(null as any),
      0,i2.CompletedPaymentMethodPixComponent,[i7.ToastrService,i6.TranslateService],
      (null as any),(null as any))],(null as any),(null as any));
}
export const CompletedPaymentMethodPixComponentNgFactory:i1.ComponentFactory<i2.CompletedPaymentMethodPixComponent> = i1.ɵccf('completed-payment-method-pix',
    i2.CompletedPaymentMethodPixComponent,View_CompletedPaymentMethodPixComponent_Host_0,
    {paymentCode:'paymentCode',paymentCodeQr:'paymentCodeQr'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2NvZGVidWlsZC9vdXRwdXQvc3JjNTYwNTk5NjQ0L3NyYy9zcmMvYXBwL2NvbXBsZXRlZC9wYXltZW50LW1ldGhvZC9waXgvY29tcGxldGVkLnBheW1lbnQtbWV0aG9kLnBpeC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vY29kZWJ1aWxkL291dHB1dC9zcmM1NjA1OTk2NDQvc3JjL3NyYy9hcHAvY29tcGxldGVkL3BheW1lbnQtbWV0aG9kL3BpeC9jb21wbGV0ZWQucGF5bWVudC1tZXRob2QucGl4LmNvbXBvbmVudC50cyIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjNTYwNTk5NjQ0L3NyYy9zcmMvYXBwL2NvbXBsZXRlZC9wYXltZW50LW1ldGhvZC9waXgvY29tcGxldGVkLnBheW1lbnQtbWV0aG9kLnBpeC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjNTYwNTk5NjQ0L3NyYy9zcmMvYXBwL2NvbXBsZXRlZC9wYXltZW50LW1ldGhvZC9waXgvY29tcGxldGVkLnBheW1lbnQtbWV0aG9kLnBpeC5jb21wb25lbnQudHMuQ29tcGxldGVkUGF5bWVudE1ldGhvZFBpeENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxpbWcgc3JjPVwiaHR0cHM6Ly9xdWlja2NoYXJ0LmlvL3FyP3RleHQ9e3twYXltZW50Q29kZVFyfX0mc2l6ZT0yNTBcIlxuICAgICBhbHQ9XCJQaXggUVItQ29kZVwiXG4gICAgIChlcnJvcik9XCJjaGFuZ2VRckNvZGVTb3VyY2UoJGV2ZW50KVwiIC8+XG48YnI+XG48YSBjbGFzcz1cImJ0biBidG4tc20gYnRuLWxpbmtcIiBuZ3hDbGlwYm9hcmQgW2NiQ29udGVudF09XCJwYXltZW50Q29kZVwiIChjYk9uU3VjY2Vzcyk9XCJjb3BpZWQoKVwiPlxuICAgIHt7J0NPTVBMRVRFRC5DT1BZX1BJWF9QQVlNRU5UX0NPREUnfHRyYW5zbGF0ZX19XG48L2E+XG4iLCI8Y29tcGxldGVkLXBheW1lbnQtbWV0aG9kLXBpeD48L2NvbXBsZXRlZC1wYXltZW50LW1ldGhvZC1waXg+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtJQUFBO0lBQUE7SUFFSztNQUFBO01BQUE7SUFBQTtJQUZMO0VBQUEsZ0NBRTRDLDBDQUM1QzthQUFBO1VBQUEsNENBQUk7TUFBQSxTQUNKO01BQUE7TUFBQTtJQUFBO0lBQUE7SUFBQTtNQUFBO01BQUE7SUFBQTtJQUFzRTtNQUFBO01BQUE7SUFBQTtJQUF0RTtFQUFBLHVDQUFBO01BQUE7TUFBQSw2QkFBK0Y7YUFBQTtNQUUzRjs7SUFGMkI7SUFBYTtJQUE1QyxXQUErQixVQUFhLFNBQTVDOzs7SUFKSztRQUFBO0lBQUwsV0FBSyxTQUFMO0lBSStGO0lBQUE7Ozs7b0JDSi9GO01BQUE7bURBQUEsVUFBQTtNQUFBO01BQUE7Ozs7In0=



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/$$_gendir/app/completed/payment-method/pix/completed.payment-method.pix.component.ngfactory.ts